import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ArcaPdfStudioLayout from '../../components/arca/ArcaPdfStudioLayout';
import { appendUploadFiles, isPdfFile } from '../../components/arca/uploadItemUtils';
import { getToken } from '../../api/client';
import API_CONFIG from '../../config/api';

function baixarBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default function ArcaPdfPdfParaJpgPage() {
  const [items, setItems] = useState([]);
  const [dpi, setDpi] = useState(150);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const file = items[0]?.file || null;

  const handleFilesAdd = (files) => {
    setError('');
    const n = appendUploadFiles(files, setItems, { multiple: false, filter: isPdfFile });
    if (!n) setError('Selecione um arquivo PDF.');
  };

  const handleConvert = async () => {
    setError('');
    if (!file) {
      setError('Envie um PDF.');
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('file', file, file.name);
      fd.append('dpi', String(dpi));
      const token = getToken();
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/arca/pdf/convert/pdf-to-jpg`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd,
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Erro na conversão (${res.status}).`);
      }
      const blob = await res.blob();
      const disposition = res.headers.get('Content-Disposition') || '';
      const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      const filename = match
        ? decodeURIComponent(match[1].replace(/"/g, ''))
        : `paginas-${Date.now()}.zip`;
      baixarBlob(blob, filename);
    } catch (e) {
      console.error('[ArcaPdfPdfParaJpg]', e);
      setError(e.message || 'Erro ao converter.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ArcaPdfStudioLayout
      title="PDF para JPG"
      info="Cada página vira uma imagem JPG (ZIP se houver mais de uma). Requer Ghostscript. Clique no thumbnail · ↻ para girar."
      limits={
        <>
          Limite: <strong>50 MB</strong> · 1 arquivo. Opcional: <code>GHOSTSCRIPT_PATH</code>.
        </>
      }
      error={error}
      onClearError={() => setError('')}
      onRotateError={setError}
      items={items}
      setItems={setItems}
      loading={loading}
      enableSortAlpha={false}
      dropzone={{
        accept: 'application/pdf,.pdf',
        multiple: false,
        maxSizeMb: 50,
        onFilesAdd: handleFilesAdd,
        label: 'Arraste um PDF ou clique para selecionar',
        hint: 'Máximo 50MB',
      }}
      sidebarExtras={
        file ? (
          <FormControl size="small" fullWidth disabled={loading} sx={{ mb: 2 }}>
            <InputLabel id="dpi-label">Qualidade (DPI)</InputLabel>
            <Select
              labelId="dpi-label"
              label="Qualidade (DPI)"
              value={dpi}
              onChange={(e) => setDpi(Number(e.target.value))}
            >
              <MenuItem value={96}>96 (rápido)</MenuItem>
              <MenuItem value={150}>150 (padrão)</MenuItem>
              <MenuItem value={200}>200</MenuItem>
              <MenuItem value={300}>300 (alta)</MenuItem>
            </Select>
          </FormControl>
        ) : null
      }
      actionLabel="Converter e baixar"
      actionLoadingLabel="Convertendo…"
      actionStartIcon={<ImageOutlinedIcon />}
      onAction={handleConvert}
      actionDisabled={!file}
    />
  );
}
